import React, { Component } from "react";
import _ from "i18n";

import { Input, Select, Option, Button } from "../UI/form";
import Editor from "./Editor";
import { Icon } from "antd";

import styles from "./List.local.scss";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveLoading: false,
      deleteLoading: false,
      addNewIndicator: false,
      current: null
    };
  }

  handleAddButton() {
    if (!this.state.addNewIndicator) {
      this.setState(state => {
        return {
          addNewIndicator: true,
          current: {
            code: null,
            id: null,
            labels: {},
            unit: "€"
          }
        };
      });
    }
  }

  handleCancelButton() {
    if (this.state.addNewIndicator) {
      this.setState(state => {
        return {
          addNewIndicator: false
        };
      });
    }
  }

  handleSwitchCurrentIndicator(indicator) {
    this.setState(state => {
      return {
        current:
          state.current && state.current.code === indicator.code
            ? null
            : { ...indicator, labels: { ...indicator.labels } },
        addNewIndicator: !indicator.code
      };
    });
  }

  handleLabelChange(code, value, language) {
    if (this.state.current && code === this.state.current.code) {
      this.setState(state => {
        let { current } = state;
        current.labels = { ...current.labels };
        current.labels[language] = value;
        return {
          current: current
        };
      });
    }
  }

  handleUnitChange(code, value) {
    if (this.state.current && code === this.state.current.code) {
      this.setState(state => {
        return {
          current: {
            ...state.current,
            unit: value
          }
        };
      });
    }
  }

  handleFormulaChange(code, value) {
    if (this.state.current && code === this.state.current.code) {
      this.setState(state => {
        return {
          current: {
            ...state.current,
            labels: { ...state.current.labels },
            formula: value
          }
        };
      });
    }
  }

  handleUpdateIndicator() {
    let { current } = this.state;
    if (current) {
      let indicators = this.props.indicators.filter(
        indicator => current.code === indicator.code
      );

      if (indicators.length) {
        this.setState(state => {
          this.props.handleUpdateIndicator(current).then(() => {
            this.setState(state => {
              return {
                saveLoading: false
              };
            });
          });
          return {
            saveLoading: true
          };
        });
      }
    }
  }

  handleDefineIndicator() {
    let { current } = this.state;
    if (current && !current.code) {
      this.props.handleDefineIndicator(current).then(() => {
        this.setState(state => {
          return {
            addNewIndicator: false,
            current: {
              code: null,
              id: null,
              labels: {},
              unit: "€"
            }
          };
        });
      });
    }
  }

  handleDeleteIndicator() {
    let { current } = this.state;
    if (current) {
      let indicators = this.props.indicators.filter(
        indicator => current.code === indicator.code
      );

      if (indicators.length) {
        this.setState(state => {
          this.props.handleDeleteIndicator(current).then(() => {
            this.setState(state => {
              return {
                deleteLoading: false
              };
            });
          });
          return {
            deleteLoading: true
          };
        });
      }
    }
  }

  handleResetIndicator(indicator) {
    this.setState(state => {
      return {
        current: { ...indicator, labels: { ...indicator.labels } }
      };
    });
  }

  isCurrent(indicator) {
    return this.state.current && indicator.code === this.state.current.code;
  }

  canAdd() {
    return (
      this.state.current.formula &&
      (this.state.current.labels.fr ||
        this.state.current.labels.nl ||
        this.state.current.labels.nl)
    );
  }

  isCurrentDifferentFrom(indicator) {
    return (
      this.isCurrent(indicator) &&
      (this.state.current.formula !== indicator.formula ||
        this.state.current.unit !== indicator.unit ||
        this.state.current.labels.fr !== indicator.labels.fr ||
        this.state.current.labels.en !== indicator.labels.en ||
        this.state.current.labels.nl !== indicator.labels.nl)
    );
  }

  renderAddForm() {
    return (
      <div className={styles.item__form}>
        <section className={styles.item__form__row}>
          {["fr", "nl", "en"].map(lng => (
            <div key={lng}>
              <Input
                light
                required
                afterInput={lng.toUpperCase()}
                placeholder="Add indicator description"
                onChange={e =>
                  this.handleLabelChange(null, e.target.value, lng)
                }
              />
            </div>
          ))}
        </section>

        <section className={styles.item__form__row}>
          <Select
            value={"€"}
            style={{ width: 140 }}
            onChange={value => this.handleUnitChange(null, value)}
          >
            <Option value="€" key="0">
              €
            </Option>
            <Option value="%" key="1">
              %
            </Option>
            <Option value="" key="2">
              {" "}
              {"None"}{" "}
            </Option>
          </Select>
        </section>

        <section className={styles.item__form__row}>
          <Editor
            supportedVars={this.props.suggestions}
            onChange={(formula, tokens) =>
              this.handleFormulaChange(null, formula)
            }
          />
        </section>

        <section className={styles.item__form__footer}>
          <Button icon={"delete"} onClick={e => this.handleCancelButton()} />
          <Button
            type={"success"}
            disabled={!this.canAdd()}
            loading={this.state.saveLoading}
            onClick={e => this.handleDefineIndicator()}
          >
            {"Save"}
          </Button>
        </section>
      </div>
    );
  }

  renderUpdateForm(indicator) {
    return (
      <div
        className={styles.item__form}
        style={{
          display: this.isCurrent(indicator) ? "block" : "none"
        }}
      >
        <section className={styles.item__form__row}>
          {["fr", "nl", "en"].map((lng, i) => (
            <div key={i}>
              <Input
                light
                required
                value={
                  this.state.current
                    ? this.state.current.labels[lng]
                    : indicator.labels[lng]
                }
                afterInput={lng.toUpperCase()}
                placeholder="Add indicator description"
                onChange={e =>
                  this.handleLabelChange(indicator.code, e.target.value, lng)
                }
              />
            </div>
          ))}
        </section>

        <section className={styles.item__form__row}>
          <Select
            value={
              this.isCurrent(indicator)
                ? this.state.current.unit
                : indicator.unit
            }
            style={{ width: 140 }}
            onChange={value => this.handleUnitChange(indicator.code, value)}
          >
            <Option value="€" key="0">
              {" "}
              €{" "}
            </Option>
            <Option value="%" key="1">
              {" "}
              %{" "}
            </Option>
            <Option value="" key="2">
              {" "}
              None{" "}
            </Option>
          </Select>
        </section>

        <section className={styles.item__form__row}>
          <Editor
            code={indicator.code}
            inputFormulaText={indicator.formula}
            supportedVars={this.props.suggestions}
            onChange={(formula, tokens) =>
              this.handleFormulaChange(indicator.code, formula)
            }
          />
        </section>

        <section className={styles.item__form__footer}>
          <Button
            icon={"delete"}
            loading={this.state.deleteLoading}
            onClick={() => this.handleDeleteIndicator(indicator)}
          />
          <Button
            icon={"rollback"}
            disabled={!this.isCurrentDifferentFrom(indicator)}
            onClick={() => this.handleResetIndicator(indicator)}
          />
          <Button
            type={"success"}
            disabled={!this.isCurrentDifferentFrom(indicator)}
            loading={this.state.saveLoading}
            onClick={() => this.handleUpdateIndicator()}
          >
            {"Save"}
          </Button>
        </section>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.list}>
        <div className={styles.header}>
          <Button
            icon={"plus"}
            type={"primary"}
            onClick={e => this.handleAddButton()}
          >
            {_("add")}
          </Button>
        </div>
        <div>
          {this.state.addNewIndicator ? this.renderAddForm() : ""}
          {this.props.indicators.map(indicator => (
            <div key={indicator.code} className={styles.item}>
              <div
                className={
                  styles.item__header +
                  (this.isCurrent(indicator) ? " " + styles.item__active : "")
                }
                onClick={() => this.handleSwitchCurrentIndicator(indicator)}
              >
                <span className={styles.item__header__title}>
                  <span className={styles.code__tag}>
                    {"#" + indicator.code + ""}
                  </span>{" "}
                  {indicator.labels[this.props.language]
                    ? " " + indicator.labels[this.props.language]
                    : ""}
                </span>
                <span className={styles.item__header__actions}>
                  <span>
                    <Icon type={this.isCurrent(indicator) ? "up" : "down"} />
                  </span>
                </span>
              </div>
              {this.renderUpdateForm(indicator)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/Indicator/List.js